import {useRouter} from 'next/router'
import {useEffect, useMemo, useState} from 'react'

import {INTERNAL_ROUTES} from '$constants/internal-routes'
import useApiQuery from '$hooks/insurance/useApiQuery'
import useInsuranceExpired from '$hooks/insurance/useInsuranceExpired'
import {getInsuranceMyAssetQuery} from '$queries/mydata/mydataQuery'

const ALLOW_EXPIRED_PAGE_LIST = [INTERNAL_ROUTES.INSURANCE_MY_HOME_DIAGNOSIS]

function useInsuranceMyAssetQuery() {
    const router = useRouter()

    const [shouldFetchExpireQuery, setShouldFetchExpireQuery] = useState(false)

    useEffect(() => {
        setShouldFetchExpireQuery(ALLOW_EXPIRED_PAGE_LIST.some((path) => path === router.pathname))
    }, [router.pathname])

    const {expired} = useInsuranceExpired({
        enabled: shouldFetchExpireQuery,
    })

    const query = useApiQuery({
        ...getInsuranceMyAssetQuery.query(),
        staleTime: 0,
    })

    const isMydataInsuranceConnected = useMemo(() => {
        const connected = query.data?.isMydataInsuranceConnected

        // 보장점검 페이지의 경우 자산이 만료되면 미연결 형상으로 노출.
        if (shouldFetchExpireQuery) {
            return connected && !expired
        }

        return connected
    }, [expired, query.data?.isMydataInsuranceConnected, shouldFetchExpireQuery])

    return {
        ...query,
        data: {...query.data, isMydataInsuranceConnected},
    }
}

export default useInsuranceMyAssetQuery
